<template>
<transition name="slide">
    <div class="task-info-footer" v-if="open" v-cloak :style="{height:getTransferingHeight(itemDetail,index)}">
        <div class="transfer-detail-title">{{$t('language.popup.transferDetails')}}</div>
        <div class="transfer-detail-des">
            <div class="transfer-detail-left" v-show="itemDetail.sourceCloudType!=='Shares'" :title="itemDetail.sourceNode|getCatalog|getCatalogTitle">{{$t('language.common.from')}}:<span class="catelog-color" style="cursor:pointer;" @click.stop="toSourceCatalog(itemDetail)">{{itemDetail.sourceNode|getCatalog}}</span></div>
             <div class="transfer-detail-left" v-show="itemDetail.sourceCloudType==='Shares'" :title="itemDetail.sourceNode|getCatalogShare|getCatalogTitle">{{$t('language.common.from')}}:
                <span class="catelog-color" @click.stop="toShareCatalog(itemDetail)" style="cursor:pointer;">{{itemDetail.sourceNode|getCatalogShare}}</span>
            </div>
            <div class="to-destine transfer-detail-right" :title="itemDetail.desNode|getCatalog|getCatalogTitle">{{$t('language.common.to')}}:<span class="catelog-color" style="cursor:pointer;" @click.stop="toAimSourceCatalog(itemDetail)">{{itemDetail.desNode|getCatalog}}</span></div>
        </div>
        <div class="transfer-detail-des">
            <div class="transfer-detail-left" v-if="itemDetail.totalFileCount">{{$t('language.common.fileProcess')}}:<span>{{itemDetail.readyTranFileCount}}/{{itemDetail.totalFileCount}}</span></div>
            <div class="to-destine" v-if="itemDetail.readedBytes">{{$t('language.common.dataProcess')}}:<span>{{itemDetail.readedBytes|formatByte}}/{{itemDetail.totalBytes|formatByte}}</span></div>
        </div>
        <div class="transfer-detail-des">
            <div style="float:left;" v-if="itemDetail.taskStartTimeLong">{{$t('language.common.startTime')}}:<span>{{itemDetail.taskStartTimeLong|transferTime}}</span></div>
            <div class="to-destine" v-if="itemDetail.itemProgressInfo&&itemDetail.itemProgressInfo.speed">{{$t('language.common.currentRate')}}:<span>{{itemDetail.itemProgressInfo.speed}}</span></div>
        </div>
        <div v-if="itemDetail.itemProgressInfo" style="marginTop:10Px;">
            <div class="task-catelog"  :key="index" v-for="(item ,index) in itemDetail.itemProgressInfo.entities">
                <div style="float:left;height:20Px;lineHeight:20Px;" :class="!isVip()?'txt-max':'txt-max-vip'" :title="getTitle(item)">{{item.fileNode|getCatalog}}\{{item.filename}}</div>
                <div v-if="!isVip()">
                <div style="float:right;" class="upgradeMulti" v-if="item.rate==-1"  @click.stop="switchToPay()">{{$t('language.common.upgradeMulti')}}</div>
                <div style="float:right;height:20Px;lineHeight:20Px;" v-if="item.rate!=-1">{{item.rate}}%</div>
                </div>
                <div v-if="isVip()">
                    <div style="float:right;height:20Px;lineHeight:20Px;" v-if="item.rate&&item.rate!=-1">{{item.rate}}%</div>
                    <div style="float:right;height:20Px;lineHeight:20Px;" v-else>0%</div>  
                </div>
            </div>
        </div>
        <div class="task-upgrade">
            <div class="icon-util shop-cart shop-cart-position"></div>
            <div :class="isVip()?'task-upgrade-des':''" v-if="!isVip()">{{$t('language.common.noVip')}}
            </div>
            <div :class="isVip()?'task-upgrade-des':''" v-if="isVip()">{{$t('language.common.vipThanks')}}</div>
        </div>
        <div class="task-upgrade-button">
            <button class="upgrade-now" v-if="!isVip()" @click.stop="switchToPay()">{{$t('language.common.upgradeNow')}}</button>
        </div>
    </div>
</transition>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import googleAnalyticsUtil from "../../../../js/workspace/google_analytics_util.js";
export default {
    props: ['open', 'index', 'itemDetail'],
    methods: {
        toShareCatalog(itemDetail){
            let allNodes = itemDetail.sourceNode;
            let nodes = commonUtils.getSharePathForCryptId(itemDetail);
            if(nodes){
                this.$store.commit("setSharePath", nodes);
            }
            let link = commonstate.sharePageUrl + allNodes[allNodes.length-1].shareId;
            window.open(link);
        },
        toSourceCatalog(itemDetail) {
            let item;
            let that = this;
            let direction = that.$parent.$parent.$parent.$parent.$parent;
            if (itemDetail.itemProgressInfo && itemDetail.itemProgressInfo.detail) {
                item = itemDetail.itemProgressInfo.detail;
            } else {
                item = itemDetail;
            }
            commonUtils.toSourceCatalog(item, this, function (res) {
                if (res.status == 200) {
                        let pathData = that.$store.state.pathJson[res.id + item.sourceToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                             $.each(item.sourceNode,function(j,jIitem){
                                  jIitem.tokenId=itemDetail.sourceToken;
                            });
                            commonUtils.encapsulationPath(item.sourceNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                        commonUtils.selectOption(itemDetail.sourceNode, direction);
                        that.$store.state.catalogFileId = item.sourceNode[0].fileId;
                        commonUtils.ifHasDataSelect(vm);
                        //关闭弹窗
                        that.$store.state.detaleProgressShow=false;
                }
            });
        },
        toAimSourceCatalog(itemDetail) {
            let that = this;
            let item;
            let direction = that.$parent.$parent.$parent.$parent.$parent;
            if (itemDetail.itemProgressInfo && itemDetail.itemProgressInfo.detail) {
                item = itemDetail.itemProgressInfo.detail;
            } else {
                item = itemDetail;
            }
            commonUtils.toAimSourceCatalog(item, this, function (res) {
                if (res.status == 200) {
                        commonUtils.selectOption(item.desNode, direction);
                        let pathData = that.$store.state.pathJson[res.id + item.desToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                            commonUtils.encapsulationPath(item.desNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                        //关闭弹窗
                        that.$store.state.detaleProgressShow=false;
                }
            });
        },
        //免费用户点击去往老版的付费界面
        switchToPay() {
            googleAnalyticsUtil.pay1(this, "threads");
            commonUtils.switchToPay();
        },
        isVip() {
            let flag = commonUtils.isVip();
            return flag;
        },
        getTransferingHeight(itemDetail, index) {
            let result;
            if (itemDetail.itemProgressInfo && itemDetail.itemProgressInfo.entities && itemDetail.itemProgressInfo.entities.length && !this.isVip()) {
                result = itemDetail.itemProgressInfo.entities.length * 25 + 20 + 'px';
            }
            if (itemDetail.itemProgressInfo && itemDetail.itemProgressInfo.entities && itemDetail.itemProgressInfo.entities.length && this.isVip()) {
                result = itemDetail.itemProgressInfo.entities.length * 25 - 55 + 'px';
            }
            return result;
        },
        getTitle(item){
            let res;
            let first=commonUtils.getCatalog(item.fileNode);
            res=first+'\\'+item.filename;
            return res;
        }
    },
}
</script>

<style>
.transfer-detail-left {
    float: left;
    max-width: 350px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task-upgrade-des {
    line-height: 18Px;
    position: relative;
    top: 10Px;
}
.slide-enter-active {
    transition: all 0.3s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.slide-leave-active {
    transition: all 0s ease;
    height: 0;
    /*no*/
    overflow: hidden;
}

.slide-enter,
.slide-leave {
    height: 0;
    opacity: 0;
}

.txt-max{
    width:490Px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 20Px;
    line-height: 20Px;
}

.txt-max-vip{
    width:95%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 20Px;
    line-height: 20Px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_transfering_detail.vue